import i18next from 'i18next';

const FREE_PALLETS_LABELS: Record<string, () => string> = {
   one: () => i18next.t('labels.free_pallets_one'),
   few: () => i18next.t('common.free'),
   many: () => i18next.t('labels.free_pallets_many'),
};

export const getFreePalletsLabel = (palletAmount: number) => {
   const pluralRules = new Intl.PluralRules('pl-PL');
   const grammaticalNumber = pluralRules.select(palletAmount);
   return FREE_PALLETS_LABELS[grammaticalNumber]();
};
